"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkInfo = exports.Networks = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
var Networks;
(function (Networks) {
    Networks["VOLTA"] = "volta";
    Networks["EWC"] = "ewc";
})(Networks = exports.Networks || (exports.Networks = {}));
exports.NetworkInfo = {
    volta: {
        url: 'https://volta-rpc.energyweb.org',
        explorer: 'https://volta-explorer.energyweb.org/tx/',
        symbol: 'VOLTA',
    },
    ewc: {
        url: 'https://rpc.energyweb.org/',
        explorer: 'https://explorer.energyweb.org/tx/',
        symbol: 'EWC',
    },
};
